import { useEffect, useRef } from "react";

// "2K" cap for images sent to UE: longest side max 2048px.
export const MAX_IMAGE_DIMENSION = 2048;

// Returns the uploaded image's URL, downscaled to fit within MAX_IMAGE_DIMENSION
// when it's larger. c_limit keeps the aspect ratio and never upscales; images
// already within the cap get their original URL untouched. Done as a Cloudinary
// delivery transformation so it covers every widget source (My Files, Web
// Address, Google Drive, ...), not just local files.
export const limitImageResolution = (info, max = MAX_IMAGE_DIMENSION) => {
  const url = info?.secure_url;
  if (!url || !(info.width > max || info.height > max)) return url;
  return url.replace("/image/upload/", `/image/upload/c_limit,w_${max},h_${max}/`);
};

const UploadWidget = ({ isOpen, onSuccess, onError, options = {} }) => {
  const widgetRef = useRef();
  const onSuccessRef = useRef(onSuccess);
  const onErrorRef = useRef(onError);

  useEffect(() => {
    onSuccessRef.current = onSuccess;
  }, [onSuccess]);

  useEffect(() => {
    onErrorRef.current = onError;
  }, [onError]);

  useEffect(() => {
    if (isOpen) {
      if (!window.cloudinary) {
        console.error("Cloudinary SDK not found on window");
        onErrorRef.current?.(new Error("Cloudinary SDK not loaded"));
        return;
      }

      widgetRef.current = window.cloudinary.createUploadWidget(
        {
          cloudName: "daicbqtlb",
          uploadPreset: "imgbb_replace",
          ...options,
        },
        (error, result) => {
          if (error) {
            onErrorRef.current?.(error);
          } else {
            onSuccessRef.current?.(result);
          }
        }
      );

      widgetRef.current.open();
    } else if (widgetRef.current) {
      widgetRef.current.close();
      widgetRef.current.destroy();
      widgetRef.current = null;
    }
    return () => {
      if (widgetRef.current) {
        widgetRef.current.destroy();
        widgetRef.current = null;
      }
    };
  }, [isOpen]);

  return null;
};

export default UploadWidget;
